'use client'

import { Check, TriangleAlert } from 'lucide-react'
import { useTranslations } from 'next-intl'
import type { SubmitState } from './useFormSubmit'

/**
 * Retour d'envoi accessible.
 *
 * `role="status"` pour le succès et `role="alert"` pour l'erreur : les lecteurs
 * d'écran annoncent le résultat sans que l'utilisateur ait à chercher.
 */
export function FormFeedback({ state }: { state: SubmitState }) {
  const t = useTranslations()

  if (state === 'success') {
    return (
      <div
        role="status"
        className="bg-accent-50 ring-accent-200 flex items-start gap-4 rounded-2xl p-6 ring-1"
      >
        <span className="bg-accent-600 mt-0.5 inline-flex size-8 shrink-0 items-center justify-center rounded-full text-white">
          <Check className="size-4.5" aria-hidden="true" />
        </span>
        <div>
          <p className="text-ink-900 font-display font-bold">{t('form.successTitle')}</p>
          <p className="text-text-muted mt-1 text-sm leading-relaxed">
            {t('form.successDescription')}
          </p>
        </div>
      </div>
    )
  }

  if (state === 'error') {
    return (
      <div
        role="alert"
        className="border-danger/30 bg-danger/5 flex items-start gap-4 rounded-2xl border p-6"
      >
        <TriangleAlert className="text-danger mt-0.5 size-6 shrink-0" aria-hidden="true" />
        <div>
          <p className="text-ink-900 font-display font-bold">{t('form.errorTitle')}</p>
          <p className="text-text-muted mt-1 text-sm leading-relaxed">
            {t('form.errorDescription')}
          </p>
        </div>
      </div>
    )
  }

  return null
}
